

import { createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';
import axios  from 'config/axios';

import { setSingleCompany, setErrors,setCompanies,setCapCompanies, setCompanyNames,  setSubscriptionPlans,setFrequencies,setIndustries,setCompanyTypes,setCurrencies,setApplications,setCompanyApplications } from '../../../stores/modules/idp/companyreducer'
export const editCompany = async(companyId,data) => {
  try {
    
    const response= await axios.put(`${process.env.REACT_APP_IDP_COMPANY_ENDPOINT_URL}/company/${companyId}`,data,
    {
    'Content-Type': 'application/json',
  });
  return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};

export const fetchSingleCompany = createAsyncThunk('company/fetchSingleCompany', async ({ companyId, idToken }, { dispatch }) => {
  try {
    dispatch(setSingleCompany([]));
    setErrors([])
    
    let response = await axios.get(`${process.env.REACT_APP_IDP_COMPANY_ENDPOINT_URL}/company/${companyId}`, {
    });
    dispatch(setSingleCompany(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const resetErrors= createAsyncThunk('company/resetErrors', async ( { dispatch }) => {
dispatch(setErrors([]));
});


export const fetchSubscriptionPlans = createAsyncThunk('company/fetchSubscriptionPlans',async (idToken, { dispatch }) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_IDP_PLAN_ENDPOINT_URL}/subscription-plans`,{

      });
      dispatch(setSubscriptionPlans(response.data))
    } catch (error) {
      dispatch(setErrors(error.response));
     
    }
  }
);

export const fetchCompanyTypes= createAsyncThunk('company/fetchCompanyTypes',async (idToken, { dispatch }) => {
  try {
    
    const response = await axios.get(`${process.env.REACT_APP_IDP_DASHBOARD_ENDPOINT_URL}/companytypes`,{
    });
    dispatch(setCompanyTypes(response.data))
  } catch (error) {
    dispatch(setErrors(error.response));
   
  }
}
);

export const fetchCurrencies= createAsyncThunk('company/fetchCurrencies',async (idToken, { dispatch }) => {
  try {
    
    const response = await axios.get(`${process.env.REACT_APP_IDP_DASHBOARD_ENDPOINT_URL}/currencies`,{
    });
    dispatch(setCurrencies(response.data))
  } catch (error) {
    dispatch(setErrors(error.response));
   
  }
}
);
export const fetchFrequencies= createAsyncThunk('company/fetchFrequencies',async (idToken, { dispatch }) => {
  try {
    
    const response = await axios.get(`${process.env.REACT_APP_IDP_FREQUENCY_ENDPOINT_URL}/frequencies`,{
    });
    dispatch(setFrequencies(response.data))
  } catch (error) {
    dispatch(setErrors(error.response));
   
  }
}
);
export const fetchApplications= createAsyncThunk('company/fetchApplications',async (idToken, { dispatch }) => {
  try {    
    const response = await axios.get(`${process.env.REACT_APP_IDP_APPLICATION_ENDPOINT_URL}/applications`,{
    });
    dispatch(setApplications(response.data))
  } catch (error) {
    dispatch(setErrors(error.response));
   
  }
}
);

export const fetchIndustries= createAsyncThunk('company/fetchIndustries',async (idToken, { dispatch }) => {
  try {
    
    const params = {
      standard:"6524ebd57eec7dd11b903555"
    };
    const response = await axios.get(`${process.env.REACT_APP_IDP_INDUSTRY_ENDPOINT_URL}/getIndustriesByquery`,{
      params:params
    });
   
    dispatch(setIndustries(response.data))
  } catch (error) {
    dispatch(setErrors(error.response));
   
  }
}
);


export const deleteCompanyService = async (companyId) => {
  try {
    await axios.delete(`${process.env.REACT_APP_IDP_COMPANY_ENDPOINT_URL}/company/${companyId}`, {});
    return true;
  } 
  catch (error) {
    return false;
  }
};

export const fetchCompaniesService = createAsyncThunk('company/fetchCompanies', async ({ params, idToken }, { dispatch }) => {
  try {
    dispatch(setCompanies([]));
    const updatedParams = { ...params, page: params.page, limit: params.limit };
    const headers = {}
    if (params['x-app-slug']) {
      headers['x-app-slug'] = params['x-app-slug'];
      delete updatedParams['x-app-slug'];
    }
    if(params?.flag!=="true")
      {
    if (params.search) {
      updatedParams.search = params.search;
    }
    else {
      updatedParams.partner ="null";
    }
  }
  delete updatedParams?.flag;
  let response = await axios.get(`${process.env.REACT_APP_IDP_COMPANY_ENDPOINT_URL}/companies`, {
    params: updatedParams,
    headers: headers
  });
    dispatch(setCompanies(response.data));
   
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchCapCompaniesService = createAsyncThunk('company/fetchCapCompanies', async ({ params}, { dispatch }) => {
  try {
   
    dispatch(setCapCompanies([]));

    let response = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getcustomers`, {
      params: params,
      
    });

    dispatch(setCapCompanies(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchCompanyData = createAsyncThunk('company/fetchCompanyNamesData', async (idToken, { dispatch }) => {
  try {
    const params = {
      limit: "null",
    };

    let response = await axios.get(`${process.env.REACT_APP_IDP_COMPANY_ENDPOINT_URL}/companies`, {
    params: params,
      
    });
    dispatch(setCompanyNames(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});
export const fetchCompanyApplications = createAsyncThunk('company/fetchCompanyApplications', async ({params,idToken}, { dispatch }) => {
  try { 
      let response;
    if (params === undefined) {
      response = await axios.get(`${process.env.REACT_APP_IDP_APPLICATION_ENDPOINT_URL}/getSubscribedApplications`,);
    } else {
      response = await axios.get(`${process.env.REACT_APP_IDP_APPLICATION_ENDPOINT_URL}/getSubscribedApplications`,{params:params});
    }
    dispatch(setCompanyApplications(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchCompaniesByQuery = createAsyncThunk('company/fetchCompaniesByQuery', async (idToken, { dispatch }) => {
  try {
    
    const params = {
      arrayOf_subscriptionPlan:"61517ef5bf79ed541402b959,61517ef5bf79ed541402b95a,61517ef5bf79ed541402b95b",
project:"_id,name",
limit:"null",
    };

    let response = await axios.get(`${process.env.REACT_APP_IDP_COMPANY_ENDPOINT_URL}/companies`, {
    params: params,
      
    });
    dispatch(setCompanyNames(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});


export const fetchOverAllScore = async ({ params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_IDP_DASHBOARD_ENDPOINT_URL}/overallscore?company=`+params.company+`&standard=All`);
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
    return error
  }
};

export const fetchCompanyProfile = async(companyId) => {
  try {
    
    let response = await axios.get(`${process.env.REACT_APP_IDP_COMPANY_ENDPOINT_URL}/company/${companyId}`);
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
    return error
  }
};
export const addCompanyService = async(data) => {
  try {
    
   let response= await axios.post(`${process.env.REACT_APP_IDP_COMPANY_ENDPOINT_URL}/company/`,data,
    {
    'Content-Type': 'application/json',
  });
    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
}
